module.exports = __webpack_public_path__ + "tempShoppingCart2.svg?f75531f3d1861e2676cbb437dd7be324";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tempShoppingCart2.svg
// module id = 370
// module chunks = 0